import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type DialogDescriptionProps = DialogPrimitive.Description.Props;

const DialogDescription = ({ className, ...props }: DialogDescriptionProps) => {
  return (
    <DialogPrimitive.Description
      data-slot="dialog-description"
      className={cn(
        'text-sm text-gray-600',
        '*:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-gray-900',
        className,
      )}
      {...props}
    />
  );
};

export default DialogDescription;
